<template>
  <div class="tabs">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="联盟介绍" name="first">
        <EditorView :data="data.leagueDesc" />
      </el-tab-pane>
      <el-tab-pane label="组织架构" name="second">
        <img
          :src="data.leagueOrganImage"
          v-if="data.leagueOrganImage"
          class="tabs-organImg"
        />
      </el-tab-pane>
      <el-tab-pane label="联盟章程" name="third">
        <EditorView :data="data.leagueRules" />
      </el-tab-pane>
      <el-tab-pane label="联盟协议" name="five">
        <EditorView :data="data.leagueProtocol" />
      </el-tab-pane>
      <el-tab-pane label="联系方式" name="fourth">
        <div class="tabs-contact">
          <label>地址:</label><span>{{ data.leagueAddress }}</span>
        </div>
        <div class="tabs-contact">
          <label>电话:</label><span>{{ data.leagueTelephone }}</span>
        </div>
        <div class="tabs-contact">
          <label>Email:</label><span>{{ data.leagueEmail }}</span>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeName: "first",
      tabs: ["联盟介绍", "组织架构", "联盟章程", "联系方式", "联盟协议"],
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.tabs {
  margin-bottom: 20px;
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
    background: #eaeaea;
    border-radius: 0;
  }
  ::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    background: $theme-color;
    color: #fff;
    border: 1px solid $theme-color;
  }
  ::v-deep .el-tabs__header {
    margin-bottom: 0px;
  }
  ::v-deep .el-tabs__content {
    background: #fff;
    border: none;
    padding: 16px;
    min-height: 400px;
  }
  &-contact {
    margin-bottom: 10px;
    > label {
      margin-right: 5px;
      font-weight: bold;
    }
    &:last-child {
      margin-bottom: 10;
    }
  }
  img {
    width: 100%;
  }
}
.type {
  &-item {
    width: 120px;
    position: relative;
    text-align: center;
    background: #e0e0e0;
    color: #333;
    &.active {
      background: $theme-color;
      color: #fff;
    }
    &.active::before {
      content: "";
      position: absolute;
      width: 100%;
      display: inline-block;
      height: 2px;
      background: $theme-color;
      bottom: -1px;
      left: 0;
    }
  }
  &-more {
    padding-right: 10px;
    white-space: nowrap;
    color: $theme-color;
    font-size: 14px;
  }
}
</style>
